// beforeEach
// - 2023.08.08
export const beforeEach = async (to, from, next) => {
  // Check if route is under /car path
  const isCarRoute = to.path.startsWith('/car')
  const categoryQuery = from.query.category

  if (isCarRoute && categoryQuery && !to.query.category) {
    // Only persist category for /car routes
    next({
      ...to,
      query: {
        ...to.query,
        category: categoryQuery,
      },
    })
  }
  else {
    next()
  }
}

